<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置id">
              <j-input placeholder="请输入配置id模糊查询" v-model="queryParam.setId" type="like"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置名称">
              <j-input placeholder="请输入配置id模糊查询" v-model="queryParam.setName" type="like"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="源头业务表">
              <j-input placeholder="请输入源头业务表" v-model="queryParam.dataTable" type="like"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="目标业务表">
              <j-input placeholder="请输入目标业务表" v-model="queryParam.targetTable" type="like"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否有序">
                <j-dict-select-tag placeholder="请选择是否有序" v-model="queryParam.haveSeq" dictCode="yn" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="分组编码">
                <a-input placeholder="请输入分组编码" v-model="queryParam.groupNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="状态">
                <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.status" dictCode="data_sync_status" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="定时任务">
                <m-ore-select :showType="true"
                              showTypeName="jobDesc"
                              showTypeValue="id"
                              v-model="queryParam.jobId"
                              url="/base/busDataSyncBaseSet/getXxlJobList"
                              :asterisk="false"
                              :params="{}"
                              placeholder="请选择定时任务">
                </m-ore-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('基础数据同步配置')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定同步中心表结构吗?" @confirm="() => handlesynchronization(record)">
                  <a>同步中心表结构</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定同步数据吗?" @confirm="() => handlesynchronizationData(record)">
                  <a>同步数据</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <busDataSyncBaseSet-modal ref="modalForm" @ok="modalFormOk"></busDataSyncBaseSet-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusDataSyncBaseSetModal from './modules/BusDataSyncBaseSetModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { httpAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import MOreSelect from './modules/NAmeMOreSelect.vue'
export default {
  name: 'BusDataSyncBaseSetList',
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    BusDataSyncBaseSetModal,
    JInput,
    MOreSelect
  },
  data() {
    return {
      description: '基础数据同步配置管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '配置id',
          align: 'center',
          dataIndex: 'setId',
        },
        {
          title: '配置名称',
          align: 'center',
          dataIndex: 'setName',
        },
        {
          title: '源头数据库',
          align: 'center',
          dataIndex: 'sourceCode_dictText',
        },
        {
          title: '源头业务表',
          align: 'center',
          dataIndex: 'dataTable',
        },
        {
          title: '目标业务表',
          align: 'center',
          dataIndex: 'targetTable',
        },
        {
          title: '是否有序',
          align: 'center',
          dataIndex: 'haveSeq_dictText',
        },
        {
          title: '顺序',
          align: 'center',
          dataIndex: 'sequence',
        },
        {
          title: '分组编码',
          align: 'center',
          dataIndex: 'groupNo',
        },
        {
          title: '定时任务',
          align: 'center',
          dataIndex: 'jobDesc',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remarks',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/base/busDataSyncBaseSet/list',
        delete: '/base/busDataSyncBaseSet/delete',
        deleteBatch: '/base/busDataSyncBaseSet/deleteBatch',
        exportXlsUrl: '/base/busDataSyncBaseSet/exportXls',
        importExcelUrl: 'base/busDataSyncBaseSet/importExcel',
        centerTableStruct: '/base/busDataSyncBaseSet/centerTableStruct', //同步表结构到中心
        dataSync: '/base/busDataSyncBaseSet/dataSync', //同步数据
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    // 同步表结构到中心
    handlesynchronization(record) {
      console.log(record)
      this.requestSynchronization(this.url.centerTableStruct, { setId: record.setId }, '同步表结构到中心')
      // setId
    },
    // 同步数据
    handlesynchronizationData(record) {
      console.log(record)
      this.requestSynchronization(this.url.dataSync, { setId: record.setId }, '同步数据')
      // setId
    },
    requestSynchronization(url, record, title) {
      const that = this
      httpAction(url, record, 'post').then((res) => {
        // postAction(url, record).then((res) => {
        console.log(res)
        if (res.code == 200) {
          that.$message.success(title + ',成功')
          that.loadData()
          that.onClearSelected()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
